<template>
    <div class="auth-agreement-box">
        <section class='service-content'>
            <ul class='text-content'>
                <li class='text-item'>
                    <p class='title-section'><strong>发布时间：2022年7月11日</strong></p>
                    <p class='title-section'><strong>生效时间：2022年7月16日</strong></p>
                </li>
                <li class='text-item'>
                    <!-- <p class='title-list'>服务协议的确认和接纳</p> -->
                    <p class='text-section'>
                        《学生资格校验用户协议》（以下简称本协议）是同程旅行的运营公司同程网络科技股份有限公司（以下简称“同程旅行”）与用户 (以下简称“本人”或“您”)所订立的合约。<strong>在接受本说明之前，请您仔细阅读本说明的全部内容。若您不同意或者不能准确理解本说明的任何条款的含义，请不要进行后续操作。若您继续操作认证，即表示您与同程旅行已达成协议并同意接受本协议的全部约定内容。在接受本协议前，请您仔细阅读本协议的全部内容（特别是以粗体标注的内容）。</strong>
                    </p>
                </li>
                <li class='text-item'>
                    <p class='title-list'>学生认证服务说明</p>
                    <p class='text-section'>
                        1、学生资格校验服务：指同程旅行或将通过将您提供的身份信息与第三方权威数据源进行比对识别，并进行人工审核，审核通过后，同程旅行将对您的会员账户做特殊标识并赋予您相应的平台权益。
                    </p>
                    <p class='text-section'>
                        2、普通高等学校：简称“普通高校”，在中国是指由国家部委、省级人民政府（含新疆生产建设兵团）、省（市、区）教育行政部门主管或联合主管的实行普通高等教育的学校，包括普通本科高等学校、普通高等职业学校、普通高等专科学校等。
                    </p>
                    <p class='text-section'>
                        3、为保障您的账号安全，防止恶意刷单，满足部分服务实名需求，并向您提供更完善的服务，根据《个人信息保护法》要求，需要对您进行实名验证。您同意并授权同程网络科技股份有限公司、艺龙网信息技术（北京）有限公司、北京艺龙信息技术有限公司等同属于香港上市公司主体：同程艺龙控股有限公司旗下附属公司，以及我们的合作方根据国家相关规定，收集、储存、使用您的个人信息以便于为您提供服务时对您的身份进行必要的验证。上述的个人信息根据不同的使用场景或服务可能包括：<strong>姓名、身份证件、学校、入学时间、学号、本人照片、证件号码、证件影印件、手机号码、银行卡号、所在地区、详细地址、学信网验证码</strong>。实名认证完成后您可享受相关的产品和服务。
                    </p>
                </li>
                <li class='text-item'>
                    <p class='title-list'>学生认证服务权益说明</p>
                    <p class='text-section'>
                        1、本服务面向年龄在16-23周岁（含）之间的青年在读学生开放。
                    </p>
                    <p class='text-section'>
                        2、本协议中可提供学生权益会不定期调整，具体以平台展示或标识的具体权益为准。
                    </p>
                </li>
                <li class='text-item'>
                    <p class='title-list'>权利与义务</p>
                    <p class='text-section'>
                        <strong>1、您知晓并授权同程旅行将您提供的个人信息传递给同程旅行的合作伙伴，用于向您提供信息识别服务</strong>。同程旅行会要求该第三方依法使用您的上述信息，并应对您的信息保密。
                    </p>
                    <p class='text-section'>
                        2、本人拟通过同程旅行将本人的学生身份信息绑定本人的同程旅行登录账户。<strong>本人同意授权同程旅行获取、使用并留存本人的学生身份信息，供同程旅行帮助学生用户认证学生身份，以便认证成功后享受相应的平台会员权益</strong>，保障认证学生用户在同程旅行预订机票、酒店等产品时可以享受学生优惠价。<strong>若因信息造假导致的出票失败、出行限制等，将由本人自行承担。</strong>
                    </p>
                    <p class='text-section'>
                        3、本人知悉本人提供个人学生身份信息后可能存在的风险。
                    </p>
                    <p class='text-section'>
                        <strong>4、本人同意遵守本协议的同时，接受《同程旅行用户隐私政策》《同程旅行服务协议》《同程旅行免责说明》的约束。</strong>
                    </p>
                    <p class='text-section'>
                        5、<strong>同程旅行有权定期对学生权益内容进行调整与更新，本人同意按照更新后的权益内容执行。</strong>如具体或特定产品对学生权益的适用规则另有说明或约定的，本人同意同时遵守该规则的约束。
                    </p>
                    <p class='text-section'>
                        6、同程旅行向您承诺提供数据安全保护方面最大程度的保障。保护您的信息安全是同程旅行的一项基本原则，未经您的同意，同程旅行不会向任何公司、组织和个人披露、提供您的信息。同时，尽管同程旅行对您的信息安全保护做了极大的努力，但是仍然不能保证在现有的安全技术措施下，您的信息绝对安全。您的信息可能会因为不可抗力因素造成泄漏、被窃取等，因不可抗力原因给您造成损失的，您同意同程旅行可以免责。同程旅行提醒您提高警惕防范各类诈骗，避免不必要的损失。
                    </p>
                    <p class='text-section'>
                        7、未成年人保护
                    </p>
                    <p class='text-section text-sub-section'>
                        7.1如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。
                    </p>
                    <p class='text-section text-sub-section'>
                        7.2对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或者监护人明确同意或者保护未成年人所必要的情况下使用、恭喜、转让或披露此信息
                    </p>
                    <p class='text-section text-sub-section'>
                        7.3我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、监护人明确同意的情况下收集、使用或者公开披露未成年人的个人信息，如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据
                    </p>
                    <p class='text-section'>
                        8、其他
                    </p>
                    <p class='text-section'>
                        <strong>本人同意：因学生身份认证、学生会员权益以及履行本协议等发生纠纷的，任何一方均可向同程旅行所在地苏州工业园区人民法院提起诉讼。</strong>
                    </p>
                    <p class='text-section'>
                        <strong>本人已知悉以上所有内容的意义以及由此产生的法律效力，自愿做出上述授权，并同意承担由此带来的一切法律后果。</strong>
                    </p>
                </li>
            </ul>
        </section>
    </div>
</template>
<script>
// import { Swipe, SwipeItem, Popup, Tab, Tabs, Sticky, Toast } from 'vant'

export default {
    name: 'authAgreement',
    components: {
        // [Popup.name]: Popup,
    },
    data() {
        return {
            
        }
    },
    created() {
        _multi_bridge_ready(() => {
            window._tc_bridge_bar.set_navbar({
                param: {
                    center: [{ tagname: "title", value: '学生资格校验用户协议' }]
                },
                callback: (data) => {}
            })
        })
    },
    mounted() {
    },
    computed: {
    },
    methods: {}
}
</script>
<style lang="less" scoped>
    .auth-agreement-box{
        background: #fff;
        font-family: PingFangSC-Regular;
        -webkit-text-size-adjust: none;
        -ms-text-size-adjust: none;

        title {
            font-family: PingFangSC-Semibold;
            font-weight: bold;
            font-size: 18px;
            color: #333;
        }

        .service-content {
            padding: 8px;
            font-family: PingFangSC-Regular;
        }

        .title {
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            font-family: PingFangSC-Semibold;
        }

        .title-list {
            font-size: 20px;
            // font-weight: bold;
            // font-family: PingFangSC-Semibold;
            line-height: 45px;
        }

        .text-content {
            padding: 8px 0;
        }

        .text-item {
            margin: 8px 5px;
        }

        .text-section {
            font-size: 16px;
            line-height: 25px;
            padding: 5px;
            text-align: left;
            word-break: break-all;
        }
        .text-sub-section {
            font-size: 16px;
            line-height: 25px;
            padding: 5px;
            text-align: left;
            word-break: break-all;
            text-indent: 2rem;
        }
        .text-bold {
            font-size: 16px;
            font-family: PingFangSC-Semibold;
            font-weight: bold;
        }

        .text-unline {
            font-weight: bold;
            text-decoration: underline;
        }

        .text-right {
            padding-top: 40px;
            font-size: 16px;
            font-family: PingFangSC-Semibold;
            font-weight: bold;
            text-align: right;
        }

        .link {
            color: #007aff;
            display: inline-block;
        }

        .time {
            font-size: 15px;
            line-height: 24px;
            font-family: PingFangSC-Semibold;
            font-weight: bold;
        }
    }     
</style>